import { render, staticRenderFns } from "./ProjectStats.vue?vue&type=template&id=27c9a042&scoped=true"
import script from "./ProjectStats.vue?vue&type=script&lang=js"
export * from "./ProjectStats.vue?vue&type=script&lang=js"
import style0 from "./ProjectStats.vue?vue&type=style&index=0&id=27c9a042&prod&lang=scss&scoped=true"
import style1 from "./ProjectStats.vue?vue&type=style&index=1&id=27c9a042&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c9a042",
  null
  
)

export default component.exports